import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PricingCardProps {
    name: string;
    price: string;
    period: string;
    description: string;
    features: string[];
    isPopular?: boolean;
    buttonText?: string;
    onSelect: () => void;
    isLoading?: boolean;
}

export function PricingCard({
    name,
    price,
    period,
    description,
    features,
    isPopular,
    buttonText = 'Upgrade',
    onSelect,
    isLoading
}: PricingCardProps) {
    return (
        <div className={cn(
            "relative rounded-2xl border bg-card p-6 shadow-sm transition-all hover:shadow-md",
            isPopular ? "border-primary shadow-primary/10 scale-105 z-10" : "border-border"
        )}>
            {isPopular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground">
                    Most Popular
                </div>
            )}

            <div className="mb-6">
                <h3 className="text-lg font-semibold">{name}</h3>
                <p className="text-sm text-muted-foreground mt-1">{description}</p>
            </div>

            <div className="mb-6">
                <div className="flex items-baseline">
                    <span className="text-3xl font-bold">{price}</span>
                    <span className="text-muted-foreground ml-1">/{period}</span>
                </div>
            </div>

            <ul className="space-y-3 mb-6">
                {features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm">
                        <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                        <span>{feature}</span>
                    </li>
                ))}
            </ul>

            <Button
                className={cn("w-full", isPopular && "bg-primary hover:bg-primary/90")}
                variant={isPopular ? "default" : "outline"}
                onClick={onSelect}
                disabled={isLoading}
            >
                {isLoading ? 'Processing...' : buttonText}
            </Button>
        </div>
    );
}
